import axios from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
const serverUrl = () => process.env.REACT_APP_SERVER_URL_API || 'http://localhost:8090';

// Same rationale as ticketApi.js: a dedicated instance that reads the cookie
// per request, instead of relying on TokenContext's global interceptor.
const client = axios.create();
client.interceptors.request.use((config) => {
    const token = cookies.get('DASHBOARD_ACCESS');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export async function listOrders() {
    const { data } = await client.get(`${serverUrl()}/api/orders`);
    return data.orders;
}
